import { z } from 'zod'
import { ALL_PERMISSIONS } from '@constants/permissions'

const permissionEnum = z.enum(ALL_PERMISSIONS)

export const createRoleSchema = z.object({
  name:        z.string().min(2, 'Name must be at least 2 characters').max(60),
  description: z.string().max(200).optional().default(''),
  status:      z.enum(['active', 'inactive']).default('active'),
  permissions: z.array(permissionEnum).default([]),
})

export const editRoleSchema = createRoleSchema

export const roleFilterSchema = z.object({
  search: z.string().optional(),
  status: z.enum(['all', 'active', 'inactive']).default('all'),
  page:   z.coerce.number().int().positive().default(1),
  limit:  z.coerce.number().int().positive().max(100).default(10),
})

export const ROLE_STATUS_CONFIG = {
  active: {
    label:  'Active',
    color:  'var(--ac-success-fg)',
    bg:     'var(--ac-success-bg)',
    border: 'var(--ac-success)',
  },
  inactive: {
    label:  'Inactive',
    color:  'var(--ac-text-subtle)',
    bg:     'var(--ac-bg-subtle)',
    border: 'var(--ac-border-base)',
  },
}
